import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use"

export default class extends Controller {
  static targets = ["label", "menu", "select"]

  connect() {
    useClickOutside(this)
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden")
  }

  close() {
    this.menuTarget.classList.add("hidden")
  }

  clickOutside() {
    this.close()
  }

  select({ params: { value, label } }) {
    this.labelTarget.textContent = label
    this.selectTarget.value = value
    this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.close()
  }
}
